// AUTO-GENERATED by scripts/fetch-openapi.mjs — DO NOT EDIT MANUALLY.
// Regenerated on every build via: node scripts/fetch-openapi.mjs

import type { ZudokuConfig } from "zudoku";

export const generatedApis: ZudokuConfig["apis"] = [
  {
    type: "file",
    input: "./apis/system.json",
    path: "/catalog/system",
    label: "System Catalog",
    options: {
      disableSecurity: false,
      expandAllTags: true,
      showInfoPage: true,
      examplesLanguage: "js",
      schemaDownload: {
        enabled: true,
        fileName: "primebrick-system",
      },
    },
    categories: [
          {
                "label": "System Brick",
                "tags": [
                      "Backend",
                      "Core"
                ]
          }
    ],
  },
  {
    type: "file",
    input: "./apis/mcp.json",
    path: "/catalog/mcp",
    label: "MCP Catalog",
    options: {
      disableSecurity: false,
      expandAllTags: true,
      showInfoPage: true,
      examplesLanguage: "js",
      schemaDownload: {
        enabled: true,
        fileName: "primebrick-mcp",
      },
    },
    categories: [
          {
                "label": "System Brick",
                "tags": [
                      "MCP",
                      "AI"
                ]
          }
    ],
  },
];
